import { DATA_SUFFIX, HTML_DATA_SUFFIX } from "../../constants.js";
import * as Path from "./path.js";
import { safeDecode } from "./safe-decode.js";
/**
 * Takes a path and turns it into the relevant parts
 * @param path
 * @param base
 */
export function getPathInfo(path, options) {
    path = safeDecode(path);
    const trailingSlash = path.endsWith("/") && path !== "/";
    path = Path.normalize(path);
    const base = Path.normalize(options.base);
    const { availableLanguageTags, defaultLanguageTag } = options;
    let pathWithoutBase = path.replace(base, "/");
    const dataSuffix = pathWithoutBase.endsWith(HTML_DATA_SUFFIX)
        ? HTML_DATA_SUFFIX
        : pathWithoutBase.endsWith(DATA_SUFFIX)
            ? DATA_SUFFIX
            : undefined;
    if (dataSuffix) {
        pathWithoutBase = pathWithoutBase.replace(dataSuffix, "");
    }
    const [maybeLang, ...rest] = pathWithoutBase.split("/").filter(Boolean);
    if (!maybeLang) {
        return { base, lang: defaultLanguageTag, path: "/", dataSuffix, trailingSlash };
    }
    const lang = availableLanguageTags.includes(maybeLang) ? maybeLang : defaultLanguageTag;
    const pathSegment = availableLanguageTags.includes(maybeLang)
        ? Path.normalize(rest.join("/"))
        : Path.normalize(pathWithoutBase);
    return { base, lang, path: pathSegment, dataSuffix, trailingSlash };
}
